import * as z from "zod";

export const getOrderSourceNames = {
  name: "getOrderSourceNames" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(z.string()),
};
